import CustomPlacesAutocomplete from "../CustomPlacesAutocomplete";
import React from "react";

export default function FormDropoff({ booking, isLoaded, setBookingField }) {
  function setDropoff(dropoff) {
    setBookingField("dropoff.address", dropoff.display_name);
    setBookingField("dropoff.full_address", dropoff.display_name);
    // Use geocoding address if available (for API calls), otherwise use display_name
    setBookingField("dropoff.geocoding_address", dropoff.geocoding_address || dropoff.display_name);
    
    // Store place_id for Google Places geocoding
    setBookingField("dropoff.place_id", dropoff.place_id || null);
    
    // Store coordinates directly if available (for predefined addresses)
    // OR reset them to null if not available (switching from predefined to Google address)
    setBookingField("dropoff.lat", dropoff.lat || null);
    setBookingField("dropoff.lon", dropoff.lon || null);
  }

  // Format distance and duration
  let displayDistance = "";
  let displayDuration = "";
  if (booking.distance) {
    displayDistance = booking.distance / 1000;
    // Round to the nearest 100
    displayDistance = Math.floor(displayDistance * 100) / 100;
    displayDistance += " km";
  }
  if (booking.duration) {
    let hours = Math.floor(booking.duration / 60 / 60);
    let minutes = Math.floor(booking.duration / 60) - hours * 60;
    displayDuration = hours + "h " + minutes + "m";
  }

  if (!isLoaded)
    return (
      <div className="kt-section kt-section--first">
        <p>Loading...</p>
      </div>
    );

  return (
    <div className="kt-section kt-section--first">
      <div className="kt-section__body">
        <div className="form-group row">
          <label className="col-lg-3 col-form-label">Adresse d'arrivée *</label>
          <div className="col-lg-6">
            <CustomPlacesAutocomplete
              setSelection={setDropoff}
              value={booking.dropoff?.address || ""}
              disabled={booking.sharedBy}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-lg-3 col-form-label">
            Adresse complète d'arrivée:
          </label>
          <div className="col-lg-6">
            <input
              type="text"
              value={booking.dropoff?.full_address || ""}
              className="form-control"
              name="dropoff_full_address"
              onChange={(e) =>
                setBookingField("dropoff.full_address", e.target.value)
              }
              disabled={booking.sharedBy}
            />
          </div>
        </div>
        {(displayDistance || displayDuration) && (
          <div className="form-group row">
            <label className="col-lg-3 col-form-label"></label>
            <div className="col-lg-6">
              <div className="alert alert-light" role="alert">
                {displayDistance && displayDuration && (
                  <p className="mb-0">
                    <strong>Distance:</strong> {displayDistance} • <strong>Durée:</strong> {displayDuration}
                  </p>
                )}
                {displayDistance && !displayDuration && (
                  <p className="mb-0">
                    <strong>Distance:</strong> {displayDistance}
                  </p>
                )}
                {!displayDistance && displayDuration && (
                  <p className="mb-0">
                    <strong>Durée:</strong> {displayDuration}
                  </p>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
